<template>
    <div>
        <div class="row align-center">
            <div class="column small-12 large-10">
                <h3 class="c-heading-large u-color-white text-center">
                    {{ section_title }}
                </h3>                 
            </div>
        </div>
        <div class="row align-center">
            <div class="column small-12 large-10 align-middle">
                <div class="row small-up-2 medium-up-3 large-up-4">
                    <article v-for="usp in usps" class="c-card-usp column text-center" v-on:click.prevent="openReveal(usp)">
                        <div class="c-card-usp-wrapper u-bg-white">
                            <figure class="c-figure-usp u-bg-primary" v-if="usp.single_file">
                                <img class="c-figure-image" :src="changeImageSize(usp.single_file.media_path, 60, '_')" :alt="usp.single_file.media_title">
                            </figure>
                            <section class="c-card-usp-section">
                                <p class="c-card-usp-content u-bold u-no-margin-bottom">
                                    {{ usp.title }}
                                </p>
                            </section>
                        </div>
                    </article>
                </div>                
            </div>
        </div>
        <storage-boxes-reveal
            v-if="show_storage_boxes_reveal"
            v-on:closeStorageBoxReveal="closeStorageBoxReveal">
        </storage-boxes-reveal>
        <reviews-reveal v-if="show_reviews_reveal" v-on:closeReviewReveal="closeReviewReveal"></reviews-reveal>
        <usp-popup v-if="show_usp_popup" v-on:close="closeUspPopup" :usp="usp"></usp-popup>
    </div>
</template>
<script>
    import StorageBoxesReveal   from '../../global/storage-boxes-reveal';
    import ReviewsReveal        from '../../global/reviews-reveal';
    import UspPopup             from './usp-popup';

    export default {
        name: 'usp-overview',
        props: ['section_title'],
        data() {
            return {
                show_storage_boxes_reveal: false,
                show_reviews_reveal: false,
                show_usp_popup: false,
                storage_box: null,
                usps: [],
                usp: null,
            }
        },
        components: {
            'storage-boxes-reveal':     StorageBoxesReveal,
            'reviews-reveal':           ReviewsReveal,
            'usp-popup':                UspPopup
        },
        mounted() {
            this.getUsps()
        },
        methods: {
            /**
             * Get usps from the API
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            getUsps() {
                axios.get('/api/usp')
                    .then(this.setUsps)
            },
            /**
             * Set the usps after retrieving them from the url
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param response
             */
            setUsps(response) {
                this.usps = response.data;
            },
            /**
             * Open belonging reveal
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param usp
             * @return void
             */
            openReveal(usp) {
                this.usp = usp;
                // if the overlay is quotation, open the quotation reveal
                if(usp.overlay === 'quotation') {
                    window.location.href = 'box-huren/box-en-locatie';
                // if the overlay is boxes, open the storage boxes reveal
                } else if(usp.overlay === 'boxes') {
                    this.show_storage_boxes_reveal = true;
                // if the overlay is reviews, open the reviews reveal
                } else if(usp.overlay === 'reviews') {
                    this.show_reviews_reveal = true;
                // if the overlay is none of the above, it should be a default USP popup
                } else if(usp.overlay === 'article') {
                    this.show_usp_popup = true;
                }
            },
            /**
             * Close storage box reveal
             *
             * @author Rick van der Burg <rick@click.nl>
             * @param storage_box
             * @return void
             */
            closeStorageBoxReveal(storage_box) {
                this.show_storage_boxes_reveal = false;
            },
            /**
             * Close the review reveal
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            closeReviewReveal() {
                this.show_reviews_reveal = false;
            },
            /**
             * Close the usp popup
             *
             * @author Rick van der Burg <rick@click.nl>
             * @return void
             */
            closeUspPopup() {
                this.show_usp_popup = false;
            },
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/frontend/vue/components/usps/usp-overview.vue